import {
    CONTENT_EDITOR_ROLE,
    GAME_QA_ROLE,
    MARKETING_QA_ROLE,
    REFUNDS_ROLE
} from "@constants/ENV";
import {GAMES_PATH, LOGIN_PATH, REFUNDS_PATH} from "@constants/Paths";
import {AUTHORIZED_GROUPS} from "@constants/StorageKeys";

const GAMES_ROLES = [
    CONTENT_EDITOR_ROLE,
    GAME_QA_ROLE,
    MARKETING_QA_ROLE
];

export const toBoolean = value => value === true || value === 'true' || value === 1 || value === '1';

const parseGroupNames = value => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value !== 'string' || !value) return [];

    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed.filter(Boolean) : [value];
    } catch (error) {
        return [value];
    }
};

const getAuthorizedGroupNames = ({authorizedGroupNames, authorizedGroupName} = {}) => {
    const explicitGroups = parseGroupNames(authorizedGroupNames);
    if (explicitGroups.length) return explicitGroups;

    if (authorizedGroupName !== undefined) {
        const explicitGroup = parseGroupNames(authorizedGroupName);
        if (explicitGroup.length) return explicitGroup;
    }

    const storedGroups = parseGroupNames(localStorage.getItem(AUTHORIZED_GROUPS));
    if (storedGroups.length) return storedGroups;

    return parseGroupNames(localStorage.getItem('group'));
};

export const hasGroup = (groupName, accessSource) =>
    getAuthorizedGroupNames(accessSource).includes(groupName);

export const getAccessState = ({authorizedGroupName, authorizedGroupNames, canRefund} = {}) => {
    const groups = getAuthorizedGroupNames({authorizedGroupName, authorizedGroupNames});
    const resolvedCanRefund = canRefund === undefined ? localStorage.getItem('canRefund') : canRefund;

    return {
        groups,
        hasGamesAccess: groups.some(groupName => GAMES_ROLES.includes(groupName)),
        hasRefundAccess: groups.includes(REFUNDS_ROLE) || toBoolean(resolvedCanRefund)
    };
};

export const getDefaultRoute = ({authorizedGroupName, authorizedGroupNames, canRefund} = {}) => {
    const access = getAccessState({authorizedGroupName, authorizedGroupNames, canRefund});

    if (access.hasGamesAccess) return GAMES_PATH;
    if (access.hasRefundAccess) return REFUNDS_PATH;
    return LOGIN_PATH;
};
